import { render, staticRenderFns } from "./UserWishSupport.vue?vue&type=template&id=3aed169d&scoped=true&lang=html&"
import script from "./UserWishSupport.vue?vue&type=script&lang=js&"
export * from "./UserWishSupport.vue?vue&type=script&lang=js&"
import style0 from "./UserWishSupport.vue?vue&type=style&index=0&id=3aed169d&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3aed169d",
  null
  
)

export default component.exports